(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/bank-account/bank-account-card.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/bank-account/bank-account-card.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  CardBody,
  CardExpandableBody
} = svs.ui.ReactCard;
const {
  WhiteCardHeader,
  PdCard
} = svs.myProfile.react.pages.myInformation.myInformation.components;
const {
  IconText
} = svs.tb_ui_react.icon_text;
const NO_BANK_ACCOUNT = 'Du har inget bankkonto angivet';
const NOT_VALIDATED_BANK_ACCOUNT = 'Ditt bankkonto är obekräftat';
const BankAccountCard = () => {
  const {
    clearingNumber,
    accountNumber,
    isValidated
  } = ReactRedux.useSelector(state => state.playerDetails.playerBankAccount);
  const withdrawalUrl = svs.core.urlMapping.get('transactionsWithdrawal');
  const thisModuleUrl = "".concat(svs.core.urlMapping.get('myProfileHome'), "/uppgifter");
  const bankAccountHref = "".concat(withdrawalUrl, "/bankkonto/").concat(accountNumber ? 'byt' : 'registrera', "?returnUrl=").concat(thisModuleUrl);
  const isBankAccountExists = Boolean(clearingNumber && accountNumber);
  const isBankOk = isBankAccountExists && isValidated;
  return React.createElement("div", {
    className: "margin-bottom-4"
  }, React.createElement(PdCard, null, React.createElement(WhiteCardHeader, null, "Bankkonto"), React.createElement(CardBody, {
    className: "f-left pd-card-body"
  }, isBankAccountExists && "".concat(clearingNumber, "-").concat(accountNumber), !isBankOk && React.createElement(IconText, {
    className: isBankAccountExists ? 'padding-top-1' : ''
  }, isBankAccountExists ? NOT_VALIDATED_BANK_ACCOUNT : NO_BANK_ACCOUNT)), React.createElement(CardExpandableBody, {
    className: "f-left pd-card-body"
  }, React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    href: bankAccountHref,
    size: 300,
    transparent: true
  }, isBankAccountExists ? 'Ändra bankkonto' : 'Registrera bankkonto'))));
};
svs.myProfile.react.pages.myInformation.myInformation.components.BankAccountCard = BankAccountCard;

 })(window);